import { render } from "./joinSetting.vue?vue&type=template&id=6e025356&scoped=true"
import script from "./joinSetting.vue?vue&type=script&lang=js"
export * from "./joinSetting.vue?vue&type=script&lang=js"

import "./joinSetting.vue?vue&type=style&index=0&id=6e025356&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e025356"]])

export default __exports__